import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import i18next from "i18next";

export const useErrorHandler = (
  error,
  showNotification,
  setPageError = null
) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!error) return;
    if (
      (error?.isPageError === undefined || error?.isPageError === false) &&
      error?.errCode / 100 !== 5
    ) {
      let onClick = () => {};
      if (error.errCode === 401 || error.errCode === 409)
        onClick = () => {
          navigate("/login");
        };
      else if (error.errCode === 403)
        onClick = () => {
          navigate(-1);
        };
      showNotification(
        i18next.t("error:Error") + ": " + error.err,
        "error",
        onClick
      );
    } else if (error && setPageError !== undefined && setPageError !== null) {
      setPageError(error);
    }
  }, [error]);
};
